import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Grid from '@material-ui/core/Grid';
import { gsap } from 'gsap';
import { Typography, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import htmlParse from 'react-html-parser';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import AppContext from '../../contexts/AppContext';
import selectedJson from '../../data/selected.json';
import About from '../UI/About';
import GridIcon from '../../icons/GridIcon';
import './HomeLayer.css';
import { withOrientationChange } from 'react-device-detect';
import { isMobile } from 'react-device-detect';
import ShareIcon from '@material-ui/icons/Share';

const styles = (theme) => ({
  gridList: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(2),
    margin: '0px !important',
  },

  headerGrid: {},
  title: {
    color: 'black',
  },
  subtitle: {
    color: 'black',
  },
  titleBar: {
    background: 'white',
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  avatar: {
    margin: 10,
    width: 200,
    height: 200,
  },
  margin: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});

class HomeLayerMobile extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.leftCol = null;
    this.locationsManager = props.locManager;

    this.transitionDuration = 0.5;

    this.state = {
      step: 'pick-location',
      mode: 'inspire-me',
      showList: this.props.showList,
      selectedCity: null,
      expanded: this.props.expanded,
    };
    this.gridData = [];
  }

  componentDidMount() {
    gsap.to(this.leftCol, { left: 0, duration: this.transitionDuration });

    /*
    this.setFromLocation();
    */
  }

  componentDidUpdate(prevProps) {
    if (this.props.expanded !== prevProps.expanded) {
      this.setState({
        expanded: this.props.expanded,
      });
    }

    if (this.props.mode !== prevProps.mode) {
      if (this.props.mode === 'about') {
        this.setState({
          mode: 'about',
          selectedCity: null,
          showList: true,
        });
      }
    }

    if (this.props.location !== prevProps.location) {
      if (this.props.location.pathname === '/create-artwork') {
        // this.createArtworkHandler(false);
      }
      if (this.props.location.pathname === '/inspire-me') {
        this.inspireMeHandler(false);
      }
      if (this.props.location.pathname === '/about') {
        this.aboutHandler(false);
      }
      if (this.props.location.pathname === '/') {
        this.setState({
          showList: false,
        });
      }
    }
  }

  setFromLocation() {
    if (this.props.mode === 'about') {
      this.aboutHandler(false);
    }
  }

  aboutHandler(updateRoute = true) {
    this.setState(
      {
        showList: false,
      },
      () => {
        this.setState(
          {
            mode: 'about',
            selectedCity: null,
            showList: true,
          },
          () => {
            if (updateRoute) this.props.onStateChange(this.state.mode);
          },
        );
      },
    );
  }

  inspireMeHandler(updateRoute = true) {
    this.gridData = [];
    this.setState(
      {
        showList: false,
      },
      () => {
        this.setState({
          mode: 'inspire-me',
          selectedCity: null,
          showList: true,
        });
      },
      () => {
        if (updateRoute) this.props.onStateChange(this.state.mode);
      },
    );
  }

  onClickHandler(item) {
    if (this.state.mode === 'inspire-me') {
      if (item.panoid) {
        this.props.onCityClickHandler(item);

        this.setState(
          {
            mode: '',
            selectedCity: null,
            showList: false,
          },
          () => {
            this.props.onStateChange(this.state.mode);
          },
        );

        return;
      }
      this.props.onLocationClickHandler(item);
      this.setState({ showList: false });
    }
  }

  render() {
    const { classes, isLandscape, isPortrait } = this.props;
    const { dictionnary } = this.context;

    this.gridData = [];
    let headerContent = null;
    if (this.state.mode === 'inspire-me') {
      headerContent = <>{dictionnary.get('home-location-list-mobile')}</>;
      this.gridData = selectedJson;
    }

    let descrContent = [];
    if (this.state.mode === 'about') {
      headerContent = <>About</>;
      descrContent = <About dictionnary={dictionnary}></About>;
    }

    const containerStyle = this.state.expanded
      ? { bottom: 0, background: 'white' }
      : {
          bottom: '-125px',
          color: 'white',
        };
    const expandedIcon = this.state.expanded ? (
      <ExpandMoreOutlinedIcon fontSize="small" />
    ) : (
      <ExpandLessOutlinedIcon variant="contained" fontSize="small" />
    );

    const gridIconStyle = this.state.expanded
      ? {}
      : {
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          backgroundColor: 'white',
        };

    const aboutIconStyle = this.state.expanded
      ? { display: 'none' }
      : {
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: 'white',
        };
    const shareIconStyle = this.state.expanded
      ? { display: 'none' }
      : {
          position: 'fixed',
          bottom: '20px',
          right: '110px',
          backgroundColor: 'white',
        };

    return (
      <>
        {this.state.step === 'pick-location' && (
          <div className="front-layer-container">
            <Grid
              container
              spacing={0}
              className={this.state.showList ? 'blur' : ''}
            >
              {!this.state.showList && (
                <Grid item xs={12}>
                  <div
                    ref={(c) => (this.leftCol = c)}
                    className="pick-location-left-mobile"
                    style={containerStyle}
                  >
                    <div id="header-arrow">
                      <Button
                        variant="contained"
                        color="secondary"
                        id={'home-mobile-expand-btn'}
                        className={this.state.expanded ? '' : 'unexpanded'}
                        onClick={() => {
                          this.props.onHomeExpandHandler();
                        }}
                      >
                        {expandedIcon}
                      </Button>
                    </div>

                    {this.state.expanded && (
                      <div id="home-descr-container-mobile">
                        <Typography variant="body1">
                          {htmlParse(dictionnary.get('home-descr-mobile'))}
                        </Typography>
                      </div>
                    )}
                    {isPortrait && (
                      <>
                        <div id="header-left">
                          {this.state.expanded && (
                            <Typography classvariant="subtitle2">
                              {htmlParse(dictionnary.get('home-subtitle'))}
                            </Typography>
                          )}
                          <br />
                        </div>
                        <Button
                          onClick={() => {
                            this.inspireMeHandler();
                            this.props.onStateChange(this.state.mode);
                          }}
                          size="small"
                          variant={'outlined'}
                          color="secondary"
                          id={'grid-icon'}
                          style={gridIconStyle}
                        >
                          <GridIcon />
                        </Button>
                        <Button
                          variant="outlined"
                          id={'home-mobile-share-btn'}
                          className={this.state.expanded ? '' : 'unexpanded'}
                          onClick={() => {
                            this.props.onShareHandler();
                          }}
                          style={shareIconStyle}
                        >
                          <ShareIcon />
                        </Button>
                        <Button
                          variant="outlined"
                          id={'home-mobile-about-btn'}
                          className={this.state.expanded ? '' : 'unexpanded'}
                          onClick={() => {
                            this.aboutHandler();
                            this.props.onStateChange(this.state.mode);
                          }}
                          style={aboutIconStyle}
                        >
                          {dictionnary.get('home-about-mobile')}
                        </Button>
                      </>
                    )}
                    {isLandscape && (
                      <div className="buttonContainer-mobile">
                        <Button
                          onClick={() => {
                            this.inspireMeHandler();
                            this.props.onStateChange(this.state.mode);
                          }}
                          size="small"
                          variant={'outlined'}
                          color="secondary"
                          id={'grid-icon'}
                          style={gridIconStyle}
                        >
                          <GridIcon />
                        </Button>
                        <Button
                          variant="outlined"
                          id={'home-mobile-share-btn'}
                          className={this.state.expanded ? '' : 'unexpanded'}
                          onClick={() => {
                            this.props.onShareHandler();
                          }}
                          style={shareIconStyle}
                        >
                          <ShareIcon />
                        </Button>
                        <Button
                          variant="outlined"
                          id={'home-mobile-about-btn'}
                          className={this.state.expanded ? '' : 'unexpanded'}
                          onClick={() => {
                            this.aboutHandler();
                            this.props.onStateChange(this.state.mode);
                          }}
                          style={aboutIconStyle}
                        >
                          {dictionnary.get('home-about-mobile')}
                        </Button>
                        <div id="header-left">
                          {this.state.expanded && (
                            <Typography classvariant="subtitle2">
                              {htmlParse(dictionnary.get('home-subtitle'))}
                            </Typography>
                          )}
                          <br />
                        </div>
                      </div>
                    )}
                    <div
                      className="visit-mobile"
                      style={isPortrait ? { marginTop: '20px' } : {}}
                    >
                      {htmlParse(dictionnary.get('home-visit-mobile'))}
                    </div>
                  </div>
                </Grid>
              )}
              {this.state.showList && (
                <Grid item xs={12} className="pick-location-list-mobile">
                  <div className={classes.gridList}>
                    <Grid container spacing={3} id={'home-mobile-header'}>
                      <Grid item xs={10}>
                        <Box display="flex" alignItems="center">
                          <Typography
                            className={classes.headerGrid}
                            variant="h6"
                            component="h6"
                          >
                            {headerContent}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                          className={'mobile-inspireme-close-btn'}
                        >
                          <ExpandMoreOutlinedIcon
                            aria-label="close"
                            onClick={() => {
                              this.setState({ showList: false });
                              this.props.onBackButtonHandler();
                            }}
                          >
                            <CloseIcon fontSize="large" />
                          </ExpandMoreOutlinedIcon>
                        </Box>
                      </Grid>
                    </Grid>
                    {descrContent}
                    {this.gridData.length > 0 && (
                      <GridList
                        cellHeight={300}
                        spacing={15}
                        cols={isMobile ? 1 : 2}
                        id={'home-mobile-content'}
                      >
                        {this.gridData.map((item) => (
                          <GridListTile
                            onClick={() => {
                              this.onClickHandler(item);
                              this.setState({ selectedCity: item });
                            }}
                            key={item.img}
                            className="grid-list-tile active"
                          >
                            <img src={item.img} alt={item.title || item.name} />
                            <GridListTileBar
                              title={htmlParse(item.title || item.name)}
                              subtitle={<span>{htmlParse(item.subtitle)}</span>}
                              classes={{
                                root: classes.titleBar,
                                title: classes.title,
                                subtitle: classes.subtitle,
                              }}
                            />
                          </GridListTile>
                        ))}
                      </GridList>
                    )}
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        )}
      </>
    );
  }
}

export default withOrientationChange(withStyles(styles)(HomeLayerMobile));
